import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, Resolver, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { AppDispatch, RootState } from "../../store";
import { login, setUser } from "../../store/slices/authSlice";
import { closeLogin } from "../../store/slices/uiSlice";
import Button from "../Button";
import InputText from "../InputText";
import Loading from "../Loading";

const schema = yup.object({
    username: yup.string().required("Tên đăng nhập không được để trống"),
    password: yup
        .string()
        .min(6, "Mật khẩu phải có ít nhất 6 ký tự")
        .required("Mật khẩu không được để trống"),
});

type FormData = yup.InferType<typeof schema>;

function LoginPopup() {
    const dispatch = useDispatch<AppDispatch>();
    // const { loading, success } = useSelector((state: RootState) => state.auth);
    const { loading } = useSelector((state: RootState) => state.auth);
    const { control, handleSubmit, formState: { errors }, setFocus, setError } = useForm<FormData>({
        resolver: yupResolver(schema) as Resolver<FormData>,
    });
    const navigate = useNavigate();

    const onSubmit = async (data: FormData) => {
        const newData = {
            email: data.username,
            password: data.password,
        };
        try {
            const user = await dispatch(login(newData)).unwrap();
            dispatch(setUser(user));
            navigate("/")
            dispatch(closeLogin());
        } catch (err: any) {

            // Nếu user không tồn tại
            if (err?.status === 404 && err?.data?.message.includes("User not found")) {
                setError("username", { type: "server", message: "Tài khoản không tồn tại" });
                setFocus("username");
            }

            // Nếu sai mật khẩu
            else if (err?.status === 401 && err?.data?.message.includes("Invalid password")) {
                setError("password", { type: "server", message: "Mật khẩu không chính xác" });
                setFocus("password");
            }

            // Nếu trùng user (đăng ký)
            // else if (err?.status === 400 && err?.data?.message.includes("already exists")) {
            //     setError("username", { type: "server", message: "Tài khoản đã tồn tại" });
            //     setFocus("username");
            // }

            // Các lỗi khác
            else {
                console.error("Lỗi server khác:", err?.data?.message || err);
            }
        }
    };

    const onError = (err: any) => {
        const firstErrorField = Object.keys(err)[0];
        if (firstErrorField) setFocus(firstErrorField as keyof FormData);
    };

    const handleClick = () => {

    }

    return (
        <>{loading && (<Loading />)}
            <div
                className="bg-[rgba(0,0,0,0.5)] w-full h-screen fixed top-0 left-0 flex justify-center items-center z-[9999]"
                onClick={() => dispatch(closeLogin())}
            >
                <div
                    className="bg-white rounded-[10px] p-[30px] h-fit flex flex-col justify-center items-center w-[92%] max-w-[460px]"
                    onClick={(e) => e.stopPropagation()}
                >
                    <h2 className="text-dark font-bold text-[24px] text-center">Đăng Nhập</h2>
                    <p className="text-center mb-[20px]">
                        Đăng nhập để truy cập toàn bộ nội dung học tập
                    </p>

                    <form onSubmit={handleSubmit(onSubmit, onError)} className="flex flex-col w-full">
                        <div className="flex flex-col gap-x-[40px]">
                            <div className="w-full">
                                <Controller
                                    name="username"
                                    control={control}
                                    render={({ field }) => (
                                        <InputText {...field} label="Tên đăng nhập" error={errors.username?.message} />
                                    )}
                                />
                            </div>
                            <div className="w-full mt-[40px] lg:mt-[20px]">
                                <Controller
                                    name="password"
                                    control={control}
                                    render={({ field }) => (
                                        <InputText {...field} label="Mật khẩu" type="password" error={errors.password?.message} />
                                    )}
                                />
                            </div>
                        </div>
                        <Button label="Đăng Nhập" styleButton="w-full h-[45px] mx-auto mt-[20px]" type="submit" onClick={() => handleClick()} />
                    </form>
                    <Link to="/register" className="mt-[20px] text-secondary underline cursor-pointer" onClick={() => dispatch(closeLogin())}>
                        Đăng ký toàn khoản mới
                    </Link>                
                    <Link to="/forgot-password" className="mt-[20px] text-secondary underline cursor-pointer" onClick={() => dispatch(closeLogin())}>
                        Quên mật khẩu?
                    </Link>
                </div>
            </div>
        </>
    );
}

export default LoginPopup;
